import { useState } from 'react';
import { DataGrid } from '../../components/grid/DataGrid';
import { PannelloOrdini } from './PannelloOrdini';

const INTESTAZIONI: Record<string, string> = {
  DataFabbisogno: 'Serve il',
  GiorniAlFabbisogno: 'Giorni',
  NumeroRichiesta: 'Richiesta',
  SiglaProduttore: 'Sigla',
  CodiceProduttore: 'Codice produttore',
  UnitaMisura: 'U.M.',
  DaOrdinare: 'Da ordinare',
  CostoStimato: 'Stimato allora',
  MigliorCostoOggi: 'Migliore oggi',
  MigliorFornitoreOggi: 'Da chi, oggi',
  FornitoreSuggerito: 'Suggerito',
  DaCodificare: 'Da codificare',
};

export function RigheDaOrdinare() {
  const [selezionati, setSelezionati] = useState<string[]>([]);
  const [decidendo, setDecidendo] = useState(false);
  // Cambiare questo numero fa rileggere la griglia: dopo aver creato gli ordini le
  // righe ordinate non sono più da ordinare, e la lista deve dirlo senza un ricarico.
  const [versione, setVersione] = useState(0);

  if (decidendo) {
    return (
      <section className="pagina">
        <PannelloOrdini
          righeSelezionate={selezionati}
          onChiudi={() => setDecidendo(false)}
          onOrdiniCreati={() => {
            setSelezionati([]);
            setVersione((v) => v + 1);
          }}
        />
      </section>
    );
  }

  return (
    <section className="pagina">
      <header className="testata-pagina">
        <div>
          <h1>Da ordinare</h1>
          <p>
            Tutto quello che i cantieri hanno chiesto e che nessuno ha ancora comprato, in
            ordine di scadenza. Accanto a ogni riga il costo che il confronto dava quando è
            stata scritta e il migliore di oggi: quando i due non coincidono, nel frattempo è
            cambiato un listino.
          </p>
        </div>
      </header>

      {/* La barra sta sopra la griglia e non sotto: quando si spunta la ventesima riga
          della pagina, un tasto in fondo alla pagina è un tasto che non si vede. */}
      <div className={`barra-selezione ${selezionati.length > 0 ? 'attiva' : ''}`}>
        {selezionati.length === 0 ? (
          <span className="istruzione">Spunta le righe da comprare, poi scegli i fornitori.</span>
        ) : (
          <>
            <strong>
              {selezionati.length === 1 ? '1 riga spuntata' : `${selezionati.length} righe spuntate`}
            </strong>
            <button type="button" onClick={() => setSelezionati([])}>
              Togli le spunte
            </button>
            <button type="button" className="primario" onClick={() => setDecidendo(true)}>
              Scegli i fornitori →
            </button>
          </>
        )}
      </div>

      <DataGrid
        nomeGriglia="dordinare"
        versione={versione}
        colonneVisibili={[
          'DataFabbisogno',
          'GiorniAlFabbisogno',
          'InRitardo',
          'NumeroRichiesta',
          'Commessa',
          'SiglaProduttore',
          'CodiceProduttore',
          'Descrizione',
          'UnitaMisura',
          'DaOrdinare',
          'CostoStimato',
          'MigliorCostoOggi',
          'MigliorFornitoreOggi',
          'DaCodificare',
        ]}
        intestazioni={INTESTAZIONI}
        selezione={{ selezionati, onCambia: setSelezionati }}
      />
    </section>
  );
}
